import { listen } from "@tauri-apps/api/event";
import { isContinuousVoiceActive } from "./continuous-voice-store";
import { isDictationAnywhereBusy } from "./dictation-anywhere/dictation-anywhere-store";
import { guideAllowsShortcut } from "./onboarding/quick-guide/guide-shortcut-gate";
import type { useDictation } from "./use-dictation";
import { useTTS } from "./use-tts";
import { getWindowRoleSync } from "./use-window-role";
import {
  armVoiceNewChatRouting,
  startLiveTalkNewChat,
  type VoiceTogglePayload,
} from "./voice-new-chat-routing";

/** Admit the taught voice shortcut before routing, narration or capture changes. */
export function attachDictationVoiceToggle(
  getState: typeof useDictation.getState,
  debug: (message: string) => void,
) {
  void listen<VoiceTogglePayload>("voice-toggle", (event) => {
    if (getWindowRoleSync() !== "owner") return;
    if (
      !guideAllowsShortcut(
        event.payload.startNewConversation
          ? "shortcut.voice.new"
          : "shortcut.voice.toggle",
      )
    )
      return;
    if (isDictationAnywhereBusy())
      return debug("voice-toggle ignored: anywhere");
    if (event.payload.extendsHeldChord) {
      // The held chord already toggled: Shift only routes it to a new chat.
      const state = getState();
      if (!isContinuousVoiceActive())
        armVoiceNewChatRouting(event.payload, state.status, state.unavailable);
      return;
    }
    if (isContinuousVoiceActive()) {
      if (event.payload.startNewConversation) {
        // The chord routes Live Talk's next turn to a new chat, exactly like
        // saying "new chat".
        startLiveTalkNewChat();
        return;
      }
      window.dispatchEvent(new Event("denker:continuous-voice-stop-requested"));
      return;
    }
    const tts = useTTS.getState();
    if (tts.isActive()) {
      debug("voice-toggle cancelling active tts (user barge-in)");
      tts.cancel("explicit");
    }
    const state = getState();
    armVoiceNewChatRouting(event.payload, state.status, state.unavailable);
    debug(
      `voice-toggle received status=${state.status} unavailable=${state.unavailable}`,
    );
    void state.toggle();
  });
}
